import React from "react"
import { Shield, Clock, Heart, Activity, Stethoscope } from "lucide-react"
import { WomenCarePageLayout } from "../../components/women-care-page-layout"

const WomenCareDetail = () => {
  return (
    <WomenCarePageLayout
      title="Breast Care Clinic"
      heroTagline="Comprehensive Breast Care with Compassion & Advanced Technology"
      heroImage="/images/portrait-newborn-baby-with-mother.jpg"

      highlights={[
        { icon: Shield, text: "Advanced diagnostic technology & modern infrastructure" },
        { icon: Clock, text: "24/7 emergency & screening services" },
        { icon: Heart, text: "Holistic care from screening to recovery" },
      ]}

      sectionTitle="Breast Care Clinic"
      description="Ensuring breast health is vital for women at every stage of life. From adolescence to post-menopause,
       regular monitoring and awareness play a crucial role in early detection and prevention of serious conditions."

      readMoreContent="Our multidisciplinary breast care team provides screening, diagnosis, surgical treatment, chemotherapy,
       radiotherapy, hormone therapy, and personalized follow-ups.With state-of-the-art equipment and evidence-based treatment
        protocols, we ensure safe, effective, and compassionate care.
        We offer specialized services including mammography, ultrasound, biopsy, and advanced surgical techniques like oncoplastic
         surgery and sentinel lymph node biopsy."

      contentImage="/images/SecondTrimester.png"

      doctors={[
        {
          name: "Dr. Swapna Pooskuru",
          designation: "Senior Consultant - Obstetrics & Gynecology",
          languages: "English, Telugu",
          location: "Madinaguda",
          image: "/images/professional-female-dermatologist.jpg",
        },
        {
          name: "Dr. Umajyothi K",
          designation: "Consultant - Gynec Oncology",
          languages: "Telugu, English",
          location: "Nallagandla",
          image: "/images/professional-female-dermatologist.jpg",
        },
        {
          name: "Dr. Chaitanya Cheeti",
          designation: "Breast Cancer Specialist",
          languages: "English, Hindi",
          location: "Madinaguda",
          image: "/images/professional-female-dermatologist.jpg",
        },
        {
          name: "Dr. Pallavi Reddy",
          designation: "Consultant - Women's Health",
          languages: "Telugu, Hindi, English",
          location: "Isnapur",
         image: "/images/professional-female-dermatologist.jpg",
        },
        {
          name: "Dr. Anusha R",
          designation: "Surgical Oncologist",
          languages: "English, Telugu",
          location: "Zaheerabad",
          image: "/images/professional-female-dermatologist.jpg",
        },
        {
          name: "Dr. Meghana S",
          designation: "Radiation Oncologist",
          languages: "English",
          location: "Nallagandla",
          image: "/images/professional-female-dermatologist.jpg",
        },
      ]}

  

      mediaItems={[
        {
          title: "Breast Cancer Awareness Program - Hyderabad",
          image: "/cancer-genetics-dna.jpg",
        },
        {
          title: "Advanced Screening Equipment Launch",
          image: "/gynecology-department.jpg",
        },
        {
          title: "Free Mammography Camp",
          image: "/immune-system-health.jpg",
        },
        {
          title: "Women’s Health Seminar 2024",
          image: "/genetic-counseling-dna-test.jpg",
        },
        {
          title: "Breast Cancer Survivors Meet",
          image: "/gynecology-department.jpg",
        },
        {
          title: "Healthcare Excellence Award",
          image: "/cancer-genetics-dna.jpg",
        },
      ]}

      faqs={[
        {
          q: "How often should I undergo breast screening?",
          a: "Women above 40 should undergo annual mammograms. Women with family history may require earlier screening as advised by their doctor.",
        },
        {
          q: "What are early warning signs of breast cancer?",
          a: "Lumps, nipple discharge, skin dimpling, breast pain, and change in size or shape are common warning signs.",
        },
        {
          q: "Is breast cancer treatable if detected early?",
          a: "Yes. Early detection significantly improves survival rates and treatment outcomes.",
        },
        {
          q: "What treatment options are available?",
          a: "Surgery, chemotherapy, radiotherapy, hormone therapy, and targeted therapy depending on diagnosis and stage.",
        },
      ]}

      ctaTitle="Request a Call Back"
    />
  )
}

export default WomenCareDetail
